module.exports = __webpack_public_path__ + "media/images/bg-cardboard-sidebar-f9d96357c6858626a8fff4ae64824a35.jpg";